import React from 'react';
import cn from 'classnames';

import type { MediaAttachment } from 'widget/types/attachments';
import { isVideo } from 'widget/utils/getAttachmentType';

import styles from './MediaViewerItem.module.scss';

type MediaViewerItemProps = {
  media: MediaAttachment;
  isHidden?: boolean;
  onTransitionEnd?: () => void;
  className?: string;
};

const MediaViewerItem: React.FC<MediaViewerItemProps> = ({
  media,
  isHidden,
  onTransitionEnd,
  className
}) => {
  const handleTransitionEnd = React.useCallback(
    (event: React.TransitionEvent) => {
      if (
        event.propertyName === 'opacity' &&
        event.target === event.currentTarget
      ) {
        onTransitionEnd?.();
      }
    },
    [onTransitionEnd]
  );

  return (
    <div
      // Синхронизировать имя атрибута DATA_SWIPE_ATTR в constants.ts
      data-swipe-target
      className={cn(
        styles['media-viewer-item'],
        isHidden && styles['media-viewer-item_hidden'],
        className
      )}
      onTransitionEnd={handleTransitionEnd}
    >
      {isVideo(media.type) ? (
        <video
          className={styles['media-viewer-item__media']}
          src={media.url}
          controls
          playsInline
        />
      ) : (
        <img
          className={styles['media-viewer-item__media']}
          src={media.url}
          alt={media.filename}
        />
      )}
    </div>
  );
};

export default React.memo(MediaViewerItem);
